(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core.js', './Kotlin-DateTime-library-kotlinx-datetime-js-ir.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./Kotlin-DateTime-library-kotlinx-datetime-js-ir.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-dsl-f2-dsl-cqrs'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'fixers-f2-f2-dsl-f2-dsl-cqrs'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-dsl-f2-dsl-cqrs'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'fixers-f2-f2-dsl-f2-dsl-cqrs'.");
    }
    if (typeof this['Kotlin-DateTime-library-kotlinx-datetime-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'fixers-f2-f2-dsl-f2-dsl-cqrs'. Its dependency 'Kotlin-DateTime-library-kotlinx-datetime-js-ir' was not found. Please, check whether 'Kotlin-DateTime-library-kotlinx-datetime-js-ir' is loaded prior to 'fixers-f2-f2-dsl-f2-dsl-cqrs'.");
    }
    root['fixers-f2-f2-dsl-f2-dsl-cqrs'] = factory(typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined' ? {} : this['fixers-f2-f2-dsl-f2-dsl-cqrs'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-core'], this['Kotlin-DateTime-library-kotlinx-datetime-js-ir']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_datetime) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.fa;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var System_instance = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.a;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.da;
  var defineProp = kotlin_kotlin.$_$.b9;
  var classMeta = kotlin_kotlin.$_$.z8;
  var RuntimeException = kotlin_kotlin.$_$.jd;
  var RuntimeException_init_$Init$ = kotlin_kotlin.$_$.z1;
  var captureStack = kotlin_kotlin.$_$.t8;
  var listOf = kotlin_kotlin.$_$.v6;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.j5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var plus = kotlin_kotlin.$_$.c7;
  var hashCode = kotlin_kotlin.$_$.j9;
  var getBooleanHashCode = kotlin_kotlin.$_$.f9;
  var equals = kotlin_kotlin.$_$.c9;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var getKClass = kotlin_kotlin.$_$.f;
  var PolymorphicSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
  var SealedClassSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Message, 'Message', interfaceMeta);
  setMetadataFor(Command, 'Command', interfaceMeta, VOID, [Message]);
  setMetadataFor(Event, 'Event', interfaceMeta, VOID, [Message]);
  setMetadataFor(Query, 'Query', interfaceMeta, VOID, [Message]);
  setMetadataFor(F2ErrorDTO, 'F2ErrorDTO', interfaceMeta);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(F2Error, 'F2Error', classMeta, VOID, [F2ErrorDTO], VOID, VOID, {0: $serializer_getInstance});
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(F2Exception, 'F2Exception', classMeta, RuntimeException);
  function and(match) {
    return new AndMatch(listOf([this, match]));
  }
  function or(match) {
    return new OrMatch(listOf([this, match]));
  }
  setMetadataFor(Match, 'Match', interfaceMeta);
  setMetadataFor(AndMatch, 'AndMatch', classMeta, VOID, [Match]);
  setMetadataFor(OrMatch, 'OrMatch', classMeta, VOID, [Match]);
  setMetadataFor(SortDTO, 'SortDTO', interfaceMeta);
  setMetadataFor(PageDTO, 'PageDTO', interfaceMeta);
  setMetadataFor(Companion_1, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor($serializer_0, '$serializer', classMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Page, 'Page', classMeta, VOID, [PageDTO], VOID, VOID, {0: Companion_getInstance_1});
  setMetadataFor(PageQueryDTO, 'PageQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(PageQueryResultDTO, 'PageQueryResultDTO', interfaceMeta, VOID, [Event, PageDTO]);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(PageQuery, 'PageQuery', classMeta, VOID, [PageQueryDTO], VOID, VOID, {0: $serializer_getInstance_0});
  setMetadataFor(Companion_3, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor($serializer_2, '$serializer', classMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(PageQueryResult, 'PageQueryResult', classMeta, VOID, [PageQueryResultDTO], VOID, VOID, {0: Companion_getInstance_3});
  setMetadataFor(Companion_4, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor(Pagination, 'Pagination', interfaceMeta, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
  setMetadataFor(OffsetPaginationDTO, 'OffsetPaginationDTO', interfaceMeta, VOID, [Pagination]);
  setMetadataFor(PagePaginationDTO, 'PagePaginationDTO', interfaceMeta, VOID, [Pagination]);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OffsetPagination, 'OffsetPagination', classMeta, VOID, [OffsetPaginationDTO], VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(PagePagination, 'PagePagination', classMeta, VOID, [PagePaginationDTO], VOID, VOID, {0: $serializer_getInstance_2});
  //endregion
  function Command() {
  }
  function Event() {
  }
  function Message() {
  }
  function Query() {
  }
  function F2ErrorDTO() {
  }
  function Companion() {
  }
  protoOf(Companion).x14 = function () {
    return $serializer_getInstance();
  };
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('f2.dsl.cqrs.error.F2Error', this, 5);
    tmp0_serialDesc.ht('message', false);
    tmp0_serialDesc.ht('id', true);
    tmp0_serialDesc.ht('timestamp', true);
    tmp0_serialDesc.ht('code', true);
    tmp0_serialDesc.ht('requestId', true);
    this.o1y_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.o1y_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.o1y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.ul(tmp0_desc);
    if (tmp9_input.km()) {
      tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.zl(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.im(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.zl(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.im(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.vl(tmp0_desc);
    return F2Error_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer).p1y = function (encoder, value) {
    var tmp0_desc = this.o1y_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.message);
    if (tmp1_output.rn(tmp0_desc, 1) ? true : !(value.id == null)) {
      tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.id);
    }
    if (tmp1_output.rn(tmp0_desc, 2) ? true : !(value.timestamp === System_instance.j1d().toString())) {
      tmp1_output.jn(tmp0_desc, 2, value.timestamp);
    }
    if (tmp1_output.rn(tmp0_desc, 3) ? true : !(value.code === 500)) {
      tmp1_output.en(tmp0_desc, 3, value.code);
    }
    if (tmp1_output.rn(tmp0_desc, 4) ? true : !(value.requestId == null)) {
      tmp1_output.nn(tmp0_desc, 4, StringSerializer_getInstance(), value.requestId);
    }
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.p1y(encoder, value instanceof F2Error ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function F2Error_init_$Init$(seen1, message, id, timestamp, code, requestId, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance().o1y_1);
    }
    $this.q1y_1 = message;
    if (0 === (seen1 & 2))
      $this.r1y_1 = null;
    else
      $this.r1y_1 = id;
    if (0 === (seen1 & 4))
      $this.s1y_1 = System_instance.j1d().toString();
    else
      $this.s1y_1 = timestamp;
    if (0 === (seen1 & 8))
      $this.t1y_1 = 500;
    else
      $this.t1y_1 = code;
    if (0 === (seen1 & 16))
      $this.u1y_1 = null;
    else
      $this.u1y_1 = requestId;
    return $this;
  }
  function F2Error_init_$Create$(seen1, message, id, timestamp, code, requestId, serializationConstructorMarker) {
    return F2Error_init_$Init$(seen1, message, id, timestamp, code, requestId, serializationConstructorMarker, objectCreate(protoOf(F2Error)));
  }
  function F2Error(message, id, timestamp, code, requestId) {
    id = id === VOID ? null : id;
    timestamp = timestamp === VOID ? System_instance.j1d().toString() : timestamp;
    code = code === VOID ? 500 : code;
    requestId = requestId === VOID ? null : requestId;
    this.q1y_1 = message;
    this.r1y_1 = id;
    this.s1y_1 = timestamp;
    this.t1y_1 = code;
    this.u1y_1 = requestId;
  }
  protoOf(F2Error).u5 = function () {
    return this.q1y_1;
  };
  protoOf(F2Error).k1y = function () {
    return this.r1y_1;
  };
  protoOf(F2Error).l1y = function () {
    return this.s1y_1;
  };
  protoOf(F2Error).m1y = function () {
    return this.t1y_1;
  };
  protoOf(F2Error).n1y = function () {
    return this.u1y_1;
  };
  protoOf(F2Error).toString = function () {
    return "F2Error(timestamp='" + this.timestamp + "', code=" + this.code + ", requestId='" + this.requestId + "', message='" + this.message + "')";
  };
  function Companion_0() {
  }
  protoOf(Companion_0).v1y = function (message, id, requestId, code, cause) {
    var tmp0_timestamp = System_instance.j1d().toString();
    return new F2Exception(new F2Error(message, id, tmp0_timestamp, code, requestId), cause);
  };
  protoOf(Companion_0).invoke = function (message, id, requestId, code, cause, $super) {
    id = id === VOID ? '' : id;
    requestId = requestId === VOID ? '' : requestId;
    code = code === VOID ? 500 : code;
    cause = cause === VOID ? null : cause;
    return this.v1y(message, id, requestId, code, cause);
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function F2Exception(error, cause) {
    cause = cause === VOID ? null : cause;
    RuntimeException_init_$Init$(error.message, cause, this);
    captureStack(this, F2Exception);
    this.error = error;
  }
  protoOf(F2Exception).w1y = function () {
    return this.error;
  };
  function Match() {
  }
  function AndMatch(matches, negative) {
    negative = negative === VOID ? false : negative;
    this.y1y_1 = matches;
    this.z1y_1 = negative;
  }
  protoOf(AndMatch).x1y = function () {
    return this.z1y_1;
  };
  protoOf(AndMatch).map = function (transform) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.y1y_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.w();
      // Inline function 'f2.dsl.cqrs.filter.AndMatch.map.<anonymous>' call
      var tmp$ret$0 = item.map(transform);
      destination.r(tmp$ret$0);
    }
    return new AndMatch(destination, this.z1y_1);
  };
  protoOf(AndMatch).not = function () {
    return this.a1z(VOID, !this.z1y_1);
  };
  protoOf(AndMatch).and = function (match) {
    return this.a1z(plus(this.y1y_1, match));
  };
  protoOf(AndMatch).b1z = function (matches, negative) {
    return new AndMatch(matches, negative);
  };
  protoOf(AndMatch).a1z = function (matches, negative, $super) {
    matches = matches === VOID ? this.y1y_1 : matches;
    negative = negative === VOID ? this.z1y_1 : negative;
    return $super === VOID ? this.b1z(matches, negative) : $super.b1z.call(this, matches, negative);
  };
  protoOf(AndMatch).toString = function () {
    return 'AndMatch(matches=' + this.y1y_1 + ', negative=' + this.z1y_1 + ')';
  };
  protoOf(AndMatch).hashCode = function () {
    var result = hashCode(this.y1y_1);
    result = imul(result, 31) + getBooleanHashCode(this.z1y_1) | 0;
    return result;
  };
  protoOf(AndMatch).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AndMatch))
      return false;
    var tmp0_other_with_cast = other instanceof AndMatch ? other : THROW_CCE();
    if (!equals(this.y1y_1, tmp0_other_with_cast.y1y_1))
      return false;
    if (!(this.z1y_1 === tmp0_other_with_cast.z1y_1))
      return false;
    return true;
  };
  function OrMatch(matches, negative) {
    negative = negative === VOID ? false : negative;
    this.c1z_1 = matches;
    this.d1z_1 = negative;
  }
  protoOf(OrMatch).x1y = function () {
    return this.d1z_1;
  };
  protoOf(OrMatch).map = function (transform) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.c1z_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.w();
      // Inline function 'f2.dsl.cqrs.filter.OrMatch.map.<anonymous>' call
      var tmp$ret$0 = item.map(transform);
      destination.r(tmp$ret$0);
    }
    return new OrMatch(destination, this.d1z_1);
  };
  protoOf(OrMatch).not = function () {
    return this.e1z(VOID, !this.d1z_1);
  };
  protoOf(OrMatch).or = function (match) {
    return this.e1z(plus(this.c1z_1, match));
  };
  protoOf(OrMatch).b1z = function (matches, negative) {
    return new OrMatch(matches, negative);
  };
  protoOf(OrMatch).e1z = function (matches, negative, $super) {
    matches = matches === VOID ? this.c1z_1 : matches;
    negative = negative === VOID ? this.d1z_1 : negative;
    return $super === VOID ? this.b1z(matches, negative) : $super.b1z.call(this, matches, negative);
  };
  protoOf(OrMatch).toString = function () {
    return 'OrMatch(matches=' + this.c1z_1 + ', negative=' + this.d1z_1 + ')';
  };
  protoOf(OrMatch).hashCode = function () {
    var result = hashCode(this.c1z_1);
    result = imul(result, 31) + getBooleanHashCode(this.d1z_1) | 0;
    return result;
  };
  protoOf(OrMatch).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrMatch))
      return false;
    var tmp0_other_with_cast = other instanceof OrMatch ? other : THROW_CCE();
    if (!equals(this.c1z_1, tmp0_other_with_cast.c1z_1))
      return false;
    if (!(this.d1z_1 === tmp0_other_with_cast.d1z_1))
      return false;
    return true;
  };
  function SortDTO() {
  }
  function PageDTO() {
  }
  function $serializer_init_$Init$(typeSerial0, $this) {
    $serializer_0.call($this);
    $this.l1z_1 = typeSerial0;
    return $this;
  }
  function $serializer_init_$Create$(typeSerial0) {
    return $serializer_init_$Init$(typeSerial0, objectCreate(protoOf($serializer_0)));
  }
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('f2.dsl.cqrs.page.Page', null, 2);
    tmp0_serialDesc.ht('total', false);
    tmp0_serialDesc.ht('items', false);
    this.m1z_1 = tmp0_serialDesc;
  }
  protoOf(Companion_1).n1z = function (typeSerial0) {
    return $serializer_init_$Create$(typeSerial0);
  };
  protoOf(Companion_1).hu = function (typeParamsSerializers) {
    return this.n1z(typeParamsSerializers[0]);
  };
  protoOf(Companion_1).o1z = function () {
    return this.m1z_1;
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function $serializer_0() {
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('f2.dsl.cqrs.page.Page', this, 2);
    tmp0_serialDesc.ht('total', false);
    tmp0_serialDesc.ht('items', false);
    this.k1z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ii = function () {
    return this.k1z_1;
  };
  protoOf($serializer_0).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), new ArrayListSerializer(this.l1z_1)];
  };
  protoOf($serializer_0).ki = function (decoder) {
    var tmp0_desc = this.k1z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.zl(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.gm(tmp0_desc, 1, new ArrayListSerializer(this.l1z_1), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zl(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.gm(tmp0_desc, 1, new ArrayListSerializer(this.l1z_1), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return Page_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_0).p1z = function (encoder, value) {
    var tmp0_desc = this.k1z_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.en(tmp0_desc, 0, value.q1z_1);
    tmp1_output.ln(tmp0_desc, 1, new ArrayListSerializer(this.l1z_1), value.r1z_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_0).ji = function (encoder, value) {
    return this.p1z(encoder, value instanceof Page ? value : THROW_CCE());
  };
  protoOf($serializer_0).xt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.l1z_1];
  };
  function Page_init_$Init$(seen1, total, items, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, Companion_getInstance_1().m1z_1);
    }
    $this.q1z_1 = total;
    $this.r1z_1 = items;
    return $this;
  }
  function Page_init_$Create$(seen1, total, items, serializationConstructorMarker) {
    return Page_init_$Init$(seen1, total, items, serializationConstructorMarker, objectCreate(protoOf(Page)));
  }
  function Page(total, items) {
    Companion_getInstance_1();
    this.q1z_1 = total;
    this.r1z_1 = items;
  }
  protoOf(Page).i1z = function () {
    return this.q1z_1;
  };
  protoOf(Page).j1z = function () {
    return this.r1z_1;
  };
  function PageQueryDTO() {
  }
  function PageQueryResultDTO() {
  }
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_0 = getKClass(OffsetPaginationDTO);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t1z_1 = [PolymorphicSerializer_init_$Create$(tmp_0, tmp$ret$2)];
  }
  protoOf(Companion_2).x14 = function () {
    return $serializer_getInstance_0();
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function $serializer_1() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('f2.dsl.cqrs.page.PageQuery', this, 1);
    tmp0_serialDesc.ht('pagination', false);
    this.u1z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ii = function () {
    return this.u1z_1;
  };
  protoOf($serializer_1).wt = function () {
    var tmp0_cached = Companion_getInstance_2().t1z_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0])];
  };
  protoOf($serializer_1).ki = function (decoder) {
    var tmp0_desc = this.u1z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    var tmp6_cached = Companion_getInstance_2().t1z_1;
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.im(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.im(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return PageQuery_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_1).v1z = function (encoder, value) {
    var tmp0_desc = this.u1z_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_2().t1z_1;
    tmp1_output.nn(tmp0_desc, 0, tmp2_cached[0], value.w1z_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_1).ji = function (encoder, value) {
    return this.v1z(encoder, value instanceof PageQuery ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_1();
    return $serializer_instance_0;
  }
  function PageQuery_init_$Init$(seen1, pagination, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_0().u1z_1);
    }
    $this.w1z_1 = pagination;
    return $this;
  }
  function PageQuery_init_$Create$(seen1, pagination, serializationConstructorMarker) {
    return PageQuery_init_$Init$(seen1, pagination, serializationConstructorMarker, objectCreate(protoOf(PageQuery)));
  }
  function PageQuery(pagination) {
    Companion_getInstance_2();
    this.w1z_1 = pagination;
  }
  protoOf(PageQuery).s1z = function () {
    return this.w1z_1;
  };
  function $serializer_init_$Init$_0(typeSerial0, $this) {
    $serializer_2.call($this);
    $this.y1z_1 = typeSerial0;
    return $this;
  }
  function $serializer_init_$Create$_0(typeSerial0) {
    return $serializer_init_$Init$_0(typeSerial0, objectCreate(protoOf($serializer_2)));
  }
  function Companion_3() {
    Companion_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('f2.dsl.cqrs.page.PageQueryResult', null, 3);
    tmp0_serialDesc.ht('pagination', false);
    tmp0_serialDesc.ht('total', false);
    tmp0_serialDesc.ht('items', false);
    this.z1z_1 = tmp0_serialDesc;
  }
  protoOf(Companion_3).n1z = function (typeSerial0) {
    return $serializer_init_$Create$_0(typeSerial0);
  };
  protoOf(Companion_3).hu = function (typeParamsSerializers) {
    return this.n1z(typeParamsSerializers[0]);
  };
  protoOf(Companion_3).o1z = function () {
    return this.z1z_1;
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function $serializer_2() {
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('f2.dsl.cqrs.page.PageQueryResult', this, 3);
    tmp0_serialDesc.ht('pagination', false);
    tmp0_serialDesc.ht('total', false);
    tmp0_serialDesc.ht('items', false);
    this.x1z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ii = function () {
    return this.x1z_1;
  };
  protoOf($serializer_2).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_1()), IntSerializer_getInstance(), new ArrayListSerializer(this.y1z_1)];
  };
  protoOf($serializer_2).ki = function (decoder) {
    var tmp0_desc = this.x1z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.im(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zl(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.gm(tmp0_desc, 2, new ArrayListSerializer(this.y1z_1), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.im(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zl(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.gm(tmp0_desc, 2, new ArrayListSerializer(this.y1z_1), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return PageQueryResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_2).a20 = function (encoder, value) {
    var tmp0_desc = this.x1z_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.nn(tmp0_desc, 0, $serializer_getInstance_1(), value.b20_1);
    tmp1_output.en(tmp0_desc, 1, value.c20_1);
    tmp1_output.ln(tmp0_desc, 2, new ArrayListSerializer(this.y1z_1), value.d20_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_2).ji = function (encoder, value) {
    return this.a20(encoder, value instanceof PageQueryResult ? value : THROW_CCE());
  };
  protoOf($serializer_2).xt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.y1z_1];
  };
  function PageQueryResult_init_$Init$(seen1, pagination, total, items, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, Companion_getInstance_3().z1z_1);
    }
    $this.b20_1 = pagination;
    $this.c20_1 = total;
    $this.d20_1 = items;
    return $this;
  }
  function PageQueryResult_init_$Create$(seen1, pagination, total, items, serializationConstructorMarker) {
    return PageQueryResult_init_$Init$(seen1, pagination, total, items, serializationConstructorMarker, objectCreate(protoOf(PageQueryResult)));
  }
  function PageQueryResult(pagination, total, items) {
    Companion_getInstance_3();
    this.b20_1 = pagination;
    this.c20_1 = total;
    this.d20_1 = items;
  }
  protoOf(PageQueryResult).s1z = function () {
    return this.b20_1;
  };
  protoOf(PageQueryResult).i1z = function () {
    return this.c20_1;
  };
  protoOf(PageQueryResult).j1z = function () {
    return this.d20_1;
  };
  function Companion_4() {
  }
  protoOf(Companion_4).x14 = function () {
    var tmp = getKClass(Pagination);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(OffsetPaginationDTO), getKClass(PagePaginationDTO)];
    // Inline function 'kotlin.arrayOf' call
    var tmp_1 = getKClass(OffsetPaginationDTO);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [];
    var tmp_2 = PolymorphicSerializer_init_$Create$(tmp_1, tmp$ret$5);
    var tmp_3 = getKClass(PagePaginationDTO);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_4 = [tmp_2, PolymorphicSerializer_init_$Create$(tmp_3, tmp$ret$8)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$14 = [];
    return SealedClassSerializer_init_$Create$('f2.dsl.cqrs.page.Pagination', tmp, tmp_0, tmp_4, tmp$ret$14);
  };
  protoOf(Companion_4).hu = function (typeParamsSerializers) {
    return this.x14();
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function Pagination() {
  }
  function OffsetPaginationDTO() {
  }
  function PagePaginationDTO() {
  }
  function Companion_5() {
  }
  protoOf(Companion_5).x14 = function () {
    return $serializer_getInstance_1();
  };
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function $serializer_3() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('f2.dsl.cqrs.page.OffsetPagination', this, 2);
    tmp0_serialDesc.ht('offset', false);
    tmp0_serialDesc.ht('limit', false);
    this.h20_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ii = function () {
    return this.h20_1;
  };
  protoOf($serializer_3).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_3).ki = function (decoder) {
    var tmp0_desc = this.h20_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.zl(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zl(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zl(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zl(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return OffsetPagination_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).i20 = function (encoder, value) {
    var tmp0_desc = this.h20_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.en(tmp0_desc, 0, value.j20_1);
    tmp1_output.en(tmp0_desc, 1, value.k20_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_3).ji = function (encoder, value) {
    return this.i20(encoder, value instanceof OffsetPagination ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_3();
    return $serializer_instance_1;
  }
  function OffsetPagination_init_$Init$(seen1, offset, limit, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_1().h20_1);
    }
    $this.j20_1 = offset;
    $this.k20_1 = limit;
    return $this;
  }
  function OffsetPagination_init_$Create$(seen1, offset, limit, serializationConstructorMarker) {
    return OffsetPagination_init_$Init$(seen1, offset, limit, serializationConstructorMarker, objectCreate(protoOf(OffsetPagination)));
  }
  function OffsetPagination(offset, limit) {
    this.j20_1 = offset;
    this.k20_1 = limit;
  }
  protoOf(OffsetPagination).e20 = function () {
    return this.j20_1;
  };
  protoOf(OffsetPagination).f20 = function () {
    return this.k20_1;
  };
  function Companion_6() {
  }
  protoOf(Companion_6).x14 = function () {
    return $serializer_getInstance_2();
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function $serializer_4() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('f2.dsl.cqrs.page.PagePagination', this, 2);
    tmp0_serialDesc.ht('page', false);
    tmp0_serialDesc.ht('size', false);
    this.l20_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ii = function () {
    return this.l20_1;
  };
  protoOf($serializer_4).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
  };
  protoOf($serializer_4).ki = function (decoder) {
    var tmp0_desc = this.l20_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.im(tmp0_desc, 0, IntSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.im(tmp0_desc, 0, IntSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return PagePagination_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_4).m20 = function (encoder, value) {
    var tmp0_desc = this.l20_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.nn(tmp0_desc, 0, IntSerializer_getInstance(), value.n20_1);
    tmp1_output.nn(tmp0_desc, 1, IntSerializer_getInstance(), value.o20_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_4).ji = function (encoder, value) {
    return this.m20(encoder, value instanceof PagePagination ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_4();
    return $serializer_instance_2;
  }
  function PagePagination_init_$Init$(seen1, page, size, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_2().l20_1);
    }
    $this.n20_1 = page;
    $this.o20_1 = size;
    return $this;
  }
  function PagePagination_init_$Create$(seen1, page, size, serializationConstructorMarker) {
    return PagePagination_init_$Init$(seen1, page, size, serializationConstructorMarker, objectCreate(protoOf(PagePagination)));
  }
  function PagePagination(page, size) {
    this.n20_1 = page;
    this.o20_1 = size;
  }
  protoOf(PagePagination).g20 = function () {
    return this.n20_1;
  };
  protoOf(PagePagination).n = function () {
    return this.o20_1;
  };
  //region block: post-declaration
  protoOf($serializer).xt = typeParametersSerializers;
  defineProp(protoOf(F2Error), 'message', function () {
    return this.u5();
  });
  defineProp(protoOf(F2Error), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(F2Error), 'timestamp', function () {
    return this.l1y();
  });
  defineProp(protoOf(F2Error), 'code', function () {
    return this.m1y();
  });
  defineProp(protoOf(F2Error), 'requestId', function () {
    return this.n1y();
  });
  protoOf(AndMatch).or = or;
  defineProp(protoOf(AndMatch), 'negative', function () {
    return this.x1y();
  });
  protoOf(OrMatch).and = and;
  defineProp(protoOf(OrMatch), 'negative', function () {
    return this.x1y();
  });
  defineProp(protoOf(Companion_1), '$cachedDescriptor', protoOf(Companion_1).o1z);
  defineProp(protoOf(Page), 'total', function () {
    return this.i1z();
  });
  defineProp(protoOf(Page), 'items', function () {
    return this.j1z();
  });
  protoOf($serializer_1).xt = typeParametersSerializers;
  defineProp(protoOf(PageQuery), 'pagination', function () {
    return this.s1z();
  });
  defineProp(protoOf(Companion_3), '$cachedDescriptor', protoOf(Companion_3).o1z);
  defineProp(protoOf(PageQueryResult), 'pagination', function () {
    return this.s1z();
  });
  defineProp(protoOf(PageQueryResult), 'total', function () {
    return this.i1z();
  });
  defineProp(protoOf(PageQueryResult), 'items', function () {
    return this.j1z();
  });
  protoOf($serializer_3).xt = typeParametersSerializers;
  defineProp(protoOf(OffsetPagination), 'offset', function () {
    return this.e20();
  });
  defineProp(protoOf(OffsetPagination), 'limit', function () {
    return this.f20();
  });
  protoOf($serializer_4).xt = typeParametersSerializers;
  defineProp(protoOf(PagePagination), 'page', function () {
    return this.g20();
  });
  defineProp(protoOf(PagePagination), 'size', function () {
    return this.n();
  });
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$dsl = $f2.dsl || ($f2.dsl = {});
    var $f2$dsl$cqrs = $f2$dsl.cqrs || ($f2$dsl.cqrs = {});
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$dsl = $f2.dsl || ($f2.dsl = {});
    var $f2$dsl$cqrs = $f2$dsl.cqrs || ($f2$dsl.cqrs = {});
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$dsl = $f2.dsl || ($f2.dsl = {});
    var $f2$dsl$cqrs = $f2$dsl.cqrs || ($f2$dsl.cqrs = {});
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$dsl = $f2.dsl || ($f2.dsl = {});
    var $f2$dsl$cqrs = $f2$dsl.cqrs || ($f2$dsl.cqrs = {});
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$dsl = $f2.dsl || ($f2.dsl = {});
    var $f2$dsl$cqrs = $f2$dsl.cqrs || ($f2$dsl.cqrs = {});
    var $f2$dsl$cqrs$error = $f2$dsl$cqrs.error || ($f2$dsl$cqrs.error = {});
    $f2$dsl$cqrs$error.F2Error = F2Error;
    defineProp($f2$dsl$cqrs$error.F2Error, 'Companion', Companion_getInstance);
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$dsl = $f2.dsl || ($f2.dsl = {});
    var $f2$dsl$cqrs = $f2$dsl.cqrs || ($f2$dsl.cqrs = {});
    var $f2$dsl$cqrs$exception = $f2$dsl$cqrs.exception || ($f2$dsl$cqrs.exception = {});
    $f2$dsl$cqrs$exception.F2Exception = F2Exception;
    defineProp($f2$dsl$cqrs$exception.F2Exception, 'Companion', Companion_getInstance_0);
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$dsl = $f2.dsl || ($f2.dsl = {});
    var $f2$dsl$cqrs = $f2$dsl.cqrs || ($f2$dsl.cqrs = {});
    var $f2$dsl$cqrs$filter = $f2$dsl$cqrs.filter || ($f2$dsl$cqrs.filter = {});
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$dsl = $f2.dsl || ($f2.dsl = {});
    var $f2$dsl$cqrs = $f2$dsl.cqrs || ($f2$dsl.cqrs = {});
    var $f2$dsl$cqrs$filter = $f2$dsl$cqrs.filter || ($f2$dsl$cqrs.filter = {});
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$dsl = $f2.dsl || ($f2.dsl = {});
    var $f2$dsl$cqrs = $f2$dsl.cqrs || ($f2$dsl.cqrs = {});
    var $f2$dsl$cqrs$page = $f2$dsl$cqrs.page || ($f2$dsl$cqrs.page = {});
    $f2$dsl$cqrs$page.Page = Page;
    defineProp($f2$dsl$cqrs$page.Page, 'Companion', Companion_getInstance_1);
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$dsl = $f2.dsl || ($f2.dsl = {});
    var $f2$dsl$cqrs = $f2$dsl.cqrs || ($f2$dsl.cqrs = {});
    var $f2$dsl$cqrs$page = $f2$dsl$cqrs.page || ($f2$dsl$cqrs.page = {});
    $f2$dsl$cqrs$page.PageQuery = PageQuery;
    defineProp($f2$dsl$cqrs$page.PageQuery, 'Companion', Companion_getInstance_2);
    $f2$dsl$cqrs$page.PageQueryResult = PageQueryResult;
    defineProp($f2$dsl$cqrs$page.PageQueryResult, 'Companion', Companion_getInstance_3);
    var $f2 = _.f2 || (_.f2 = {});
    var $f2$dsl = $f2.dsl || ($f2.dsl = {});
    var $f2$dsl$cqrs = $f2$dsl.cqrs || ($f2$dsl.cqrs = {});
    var $f2$dsl$cqrs$page = $f2$dsl$cqrs.page || ($f2$dsl$cqrs.page = {});
    $f2$dsl$cqrs$page.OffsetPagination = OffsetPagination;
    defineProp($f2$dsl$cqrs$page.OffsetPagination, 'Companion', Companion_getInstance_5);
    $f2$dsl$cqrs$page.PagePagination = PagePagination;
    defineProp($f2$dsl$cqrs$page.PagePagination, 'Companion', Companion_getInstance_6);
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = PageQueryDTO;
  _.$_$.b = PageQueryResultDTO;
  _.$_$.c = Command;
  _.$_$.d = Event;
  _.$_$.e = Query;
  //endregion
  return _;
}));

//# sourceMappingURL=fixers-f2-f2-dsl-f2-dsl-cqrs.js.map
